import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import ErrorBoundary from './../ErrorBoundary';
import { setVideoPlaying } from './../../redux/actions';
import { bgImage } from './../../scripts';
import PlayButton from './PlayButton';

class VideoPlayer extends Component {
  state = {
    url: null,
    playing: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    loop: false,
    started: false,
    buffering: false,
    opacity: {
      opacity: 0
    },
    hasEnded: false
  }
  // LIFECYCLE
  componentWillUnmount() {
    this.setState({
      playing: false,
      started: true
    });
    this.clearVideo();
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.url != this.props.current_video) {
      this.clearVideo();
      this.setState({
        url: null,
        playing: false,
        started: false,
        opacityFull: {
          opacity: 1
        },
        opacityZero: {
          opacity: 0
        }
      });
      this.player.seekTo(0);
    }
  }
  // VIDEO CONTROL HANDLERS
  clearVideo = () => {
    this.props.video_playing({
      url: null,
      header_style: ''
    });
  }

  playPause = () => {
    this.setState({
      playing: !this.state.playing
    });
  }

  stop = () => {
    this.setState({
      url: null,
      playing: false
    });
    this.clearVideo();
  }

  onPlay = () => {
    this.props.video_playing({
      url: this.props.videoId,
      header_style: 'video-playing'
    });
    setTimeout(() => {
      this.setState({
        playing: true,
        buffering: false,
        started: true,
        hasEnded: false
      });
    }, 1);
  }

  onPause = () => {
    if (!this.state.hasEnded) {
      this.setState({
        playing: false
      });
      this.props.video_playing({
        url: this.props.videoId,
        header_style: 'video-paused'
      });
    }
  }
  onEnded = () => {
    this.setState({
      url: null,
      playing: false,
      started: false,
      hasEnded: true
    });
    this.clearVideo();
  }
  onStart = () => {
    this.setState({
      started: true,
      playing: true
    });
  }
  onBuffer = () => {
    this.setState({
      buffering: true
    });
  }
  ref = player => {
    this.player = player;
  }
  render () {
    return (
      <div className="video__container">
        <ErrorBoundary>
          <div className="video__wrapper">
            <div className={((this.state.started) ? 'video__thumbnail playing' : 'video__thumbnail')} style={bgImage(this.props.videoPoster)}>
              {(this.props.videoId) && <PlayButton PlayFunction={() => this.onPlay()} CTA={this.props.cta}/>}
            </div>
            <ReactPlayer
              url={this.props.videoUrl}
              className='video'
              width={'100%'}
              height={'100%'}
              ref={this.ref}
              volume={this.state.volume}
              playing={this.state.playing}
              onStart={this.onStart}
              onPlay={this.onPlay}
              onBuffer={this.onBuffer}
              onPause={this.onPause}
              onEnded={this.onEnded}
              config={{
                vimeo: {
                  playerVars: {
                    showinfo: 0,
                    controls: 0
                  }
                }
              }}
            />
          </div>
        </ErrorBoundary>
        <style jsx>{`
          .video__container {
            display: block;
            width: 100%;
            height: 0;
            padding-bottom: 56.25%;
            overflow-y: visible;
            position: relative;
          }
          .video__wrapper {
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: black;
          }
          .video {
            position: absolute!important;
            top: 0;
            left: 0;
            bottom: ;
            right: 0;
            margin: auto;
            width: 100%;
            height: 100%;
            z-index: 100;
          }
          .video__thumbnail {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: white;
            will-change: opacity;
            transition: opacity 500ms ease;
            opacity: 1;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
          .playing {
            opacity: 0!important;
            pointer-events: none;
          }
        `}</style>
      </div>
    );
  }
}

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width,
    current_video: state.video_state.url
  }),
  dispatch => ({
    video_playing: (url) => dispatch(setVideoPlaying(url))
  })
)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/components/video-player/VideoPlayer.js